/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicItemWithRelations } from '../../models/public-item-with-relations';

export interface ConnectorGetPublicItems$Params {
  inventoryId: string;
}

export function connectorGetPublicItems(http: HttpClient, rootUrl: string, params: ConnectorGetPublicItems$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicItemWithRelations>> {
  const rb = new RequestBuilder(rootUrl, connectorGetPublicItems.PATH, 'get');
  if (params) {
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublicItemWithRelations>;
    })
  );
}

connectorGetPublicItems.PATH = '/apollon-connector/items';
